<template>
  <generic-search-result
    class="search-result item item--search-result search-result--article"
    :title="title ? title : item.title"
    :text="text ? text : item.introText"
    :badge-text="badgeText ? badgeText : 'core.search.types.article.label'"
    :badge-icon="badgeIcon ? badgeIcon : 'file'"
    :badge-theme="badgeTheme ? badgeTheme : 'lead'"
    :translate-badge-text="translateBadgeText"
    :image-url="imageUrl ? imageUrl : item.thumbnailImage"
    :tags="tags ? tags : item.Tags"
    :category="category ? category : item.Category"
    :item="item"
    :item-route="itemRoute"
    :show-actions="true"
    @search-result-item:request-close="
      $emit('search-result-item:request-close')
    "></generic-search-result>
  <!--:item-route="{}"-->
</template>

<script>
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";
import searchResultItemMixin from "@/client/extensions/mixins/search/searchResultItem.js";
export default {
  components: {
    genericSearchResult: asyncComponentFactory(
      "components/items/generic/SearchResult.vue",
      true
    ),
  },
  mixins: [searchResultItemMixin],
  emits: ["search-result-item:request-close"],
};
</script>

<style scoped lang="scss"></style>
